<template>
  <div class="container" :class="{ show: isShow }">
    <div class="header">
      <div class="row-header">
        <img src="~@/assets/images/navbar/bell.svg" alt="bell" class="icon-bell" />
        <div class="label-header">การแจ้งเตือน</div>
        <div v-if="amount.total > 0" class="amount-noti">{{ amount.total }}</div>
        <img class="icon-close" src="~@/assets/images/icon/close.svg" alt="close" @click="handleShow(false)" />
      </div>
    </div>

    <div class="tab">
      <div class="button-tab" :class="{ active: menu == 12 }" @click="handleTab(12)">
        <img class="icon-tab" src="~@/assets/images/icon/garuda.png" alt="garuda" />
        เผยแพร่
        <div v-if="amount.publish_amount > 0" class="amount-noti-tab">{{ amount.publish_amount }}</div>
      </div>
      <div class="button-tab" :class="{ active: menu == 2 }" @click="handleTab(2)">
        <img class="icon-tab" src="~@/assets/images/icon/file-import.svg" alt="file-import" />
        รับเข้าระบบ
        <div v-if="amount.waiting_amount > 0" class="amount-noti-tab">{{ amount.waiting_amount }}</div>
      </div>
      <div class="button-tab" :class="{ active: menu == 5 }" @click="handleTab(5)">
        <img class="icon-tab" src="~@/assets/images/icon/callback.svg" alt="callback" />
        ส่งคืน
        <div v-if="amount.return_amount > 0" class="amount-noti-tab">{{ amount.return_amount }}</div>
      </div>
    </div>

    <div class="tab-content">
      <div v-if="show && isShow" class="loading-noti">
        <div class="loading-noti-detail">
          <div class="donut"></div>
        </div>
      </div>
      <div v-for="(item, index) in rows" v-else :key="index" class="content">
        <div class="row">
          <div class="title-notice">
            {{ rows[index].announcement_name }}
          </div>
          <div
            class="notice-status"
            :class="rows[index].level == 1 ? 'normal' : rows[index].level == 2 ? 'warning' : 'danger'"
          >
            <font-awesome-icon class="icon-bolt" icon="bolt" />
            {{ rows[index].level_name }}
          </div>
        </div>

        <div class="row">
          <div class="date-expire">
            <img src="~@/assets/images/icon/clock.svg" alt="clock" class="icon-clock" />
            {{ rows[index].date }}
          </div>
          <div v-show="internalFlag" class="present-by">
            <img src="~@/assets/images/icon/landmark.svg" alt="landmark" class="icon-landmark" />
            เสนอโดย

            <div class="present-by-label">{{ rows[index].owner }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'NotifacationSidebar',
  props: ['isShow', 'internalFlag'],
  data: () => {
    return {
      show: false,
      menu: 12,
      rows: [],
      amount: {
        total: null,
        publish_amount: null,
        return_amount: null,
        waiting_amount: null,
      },
    }
  },
  watch: {
    isShow(disp) {
      if (disp) this.fetchNotifications()
    },
    // menu() {
    //   this.fetchNotifications()
    // },
    show() {
      document.body.style.overflow = this.show ? 'hidden' : ''
    },
  },
  methods: {
    handleShow(disp) {
      this.$emit('callbackHandleShow', disp)
    },
    handleTab(menu) {
      this.menu = menu
      this.fetchSeenNotifacation()
    },
    async fetchNotifications() {
      this.show = true
      this.axios
        .get(`/notification/count`)
        .then((response) => {
          this.$emit('updateNotiTotal', response.data.data.total)

          this.axios
            .get(`/notification?status=${this.menu}`)
            .then((response2) => {
              this.show = false
              this.rows = response2.data.data.meta_data

              this.amount = {
                total: response.data.data.total,
                publish_amount: response.data.data.publish_amount,
                return_amount: response.data.data.return_amount,
                waiting_amount: response.data.data.waiting_amount,
              }
            })
            .catch((error) => {
              this.show = false
              this.modalAlert = { showModal: true, title: 'Error', message: error.response.data.message }
            })
        })
        .catch((error) => {
          this.show = false
          this.modalAlert = { showModal: true, title: 'Error', message: error.response.data.message }
        })
    },
    async fetchSeenNotifacation() {
      this.show = true
      const { data: res } = await axios.post(`/notification/seen/${this.menu}`)
      if (res) this.fetchNotifications()
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 50%;
  min-width: 550px;
  height: 100%;
  background-color: #fff;
  transition: 0.5s;
  position: fixed;
  top: -500%;
  right: 0;
  z-index: 1;
  box-shadow: 6px 5px 13px rgb(0 0 0 / 50%);
}

.container.show {
  top: 0;
}

.header {
  border-bottom: 2px solid #e6e5ea;
  width: 100%;
  padding: 20px;
}

.icon-close {
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
}

.label-header {
  color: #333;
  font-size: 20px; // Page title - desktop
  font-weight: 600;
  line-height: 1.3;
}

.row-header {
  display: flex;
  align-items: center;
  gap: 15px;
}

.amount-noti {
  padding: 0px 10px;
  background-color: #f94859;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  height: fit-content;
}

.tab {
  border-bottom: 2px solid #e6e5ea;
  display: flex;
  position: relative;
  width: 100%;
  gap: 10px;
}

.button-tab {
  width: 100%;
  padding: 10px 15px;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  color: #015552;
  cursor: pointer;
}

.button-tab.active {
  border-bottom: 5px solid #0d304d;
}

.amount-noti-tab {
  border-radius: 10px;
  background-color: #0d304d;
  font-size: 12px;
  color: #fff;
  padding: 1px 8px;
  margin-left: 8px;
}
.tab-content {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: scroll;
  padding-bottom: 178px;
}

.content {
  padding: 25px 35px;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  gap: 10px;
  .row {
    gap: 20px;
  }
  &:nth-child(2n) {
    background-color: #f5f5f6;
  }
}

.title-notice {
  font-size: 16px;
  font-weight: 600;
  color: #0d304d;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notice-status {
  border-radius: 5px;
  padding: 2px 6px;
  font-size: 12px;
  font-weight: 500;
  width: fit-content;
  height: fit-content;
  display: flex;
  gap: 5px;
  align-items: center;

  &.normal {
    background-color: #d2eae9;
    color: #007773;
  }

  &.warning {
    background-color: #fae4e7;
    color: #f94859;
  }

  &.danger {
    background-color: #f94859;
    color: #fff;
  }
}
.date-expire {
  font-size: 14px;
  font-weight: 500;
  color: #666;
  display: flex;
  align-items: center;
  gap: 8px;
}

.present-by {
  font-size: 14px;
  font-weight: 500;
  color: #666;
  display: flex;
  align-items: center;
  gap: 8px;
}

.present-by-label {
  font-size: 12px;
  font-weight: 600;
  color: #15466e;
  border-radius: 10px;
  background-color: #a1b5c5;
  padding: 2px 10px;
}

.loading-noti {
  position: absolute;
  margin-left: -25px;
  z-index: 999999;
  left: 50%;
  top: 35%;
  transform: translate(-50%, -50%);

  .loading-noti-detail {
    position: fixed;
    top: 43%;
    width: 100%;
    height: 100%;

    .donut {
      margin: auto;
      width: 50px;
      height: 50px;

      display: block;

      background: transparent;
      border-radius: 50%;
      border: 12px solid rgba(rgb(128, 128, 128), 0.2);
      border-left: 12px solid #1a456b;
      animation: 1s rotate infinite linear;
    }
  }
}

@media screen and (max-width: 768px) {
  .container {
    width: 100%;
    min-width: 0;
    .icon-bell {
      height: 20px !important;
    }
  }
  .label-header {
    font-size: 18px;
  }
  .title-notice {
    font-size: 14px;
  }
  .notice-status {
    font-size: 12px;
  }
  .content {
    padding: 15px 20px;
    img {
      height: 18px !important;
    }
  }
  .row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .date-expire {
    font-size: 12px;
  }
  .present-by {
    flex-wrap: wrap;
    font-size: 12px;
    gap: 8px;
  }
  .present-by-label {
    font-size: 12px;
  }
  .icon-tab {
    height: 20px !important;
  }
  .button-tab {
    font-size: 14px;
    padding: 8px 10px;
  }
  .amount-noti-tab {
    font-size: 10px;
    padding: 1px 6px;
  }
}
</style>
